import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MovementBarComponent } from './movement-bar/movement-bar.component';
import { FloatingTargetComponent } from './floating-target/floating-target.component';
import { LanguageModule } from 'src/app/language/language.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LanguageModule
  ],
  declarations: [
    MovementBarComponent,
    FloatingTargetComponent,
  ],
  exports:[
    //MappingsComponent,
    MovementBarComponent,
    FloatingTargetComponent
  ],
})
export class MappingsModule { }
